import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  user_userNotificationsData: any;
  user_userNotificationsLoading: boolean;
  user_userNotificationsError: SerializedError | null;
} = {
  user_userNotificationsData: {},
  user_userNotificationsLoading: false,
  user_userNotificationsError: null,
};

export const user_userNotificationsFunc = createAsyncThunk(
  'user_userNotifications/user_userNotificationsFunc',
  async () => {
    const accessTokenJSON = localStorage.getItem('auth') as string;
    const data1 = JSON.stringify({
      query: `query UserNotifications {
        user_userNotifications {
            data {
            _id
            createdAt
            isRead
            user {
                _id
                displayImage
                displayName
            }
            updatedAt
            uid
            notificationType
            notificationPreview {
                content
                data {
                target
                targetId
                uid
                }
                name
                subject
            }
            }
        }
    }`,
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_NOTIFICATION || '',
      data1,
      JSON.parse(accessTokenJSON)?.accessToken || ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const user_userNotifications = createSlice({
  name: 'user_userNotifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(user_userNotificationsFunc.pending, (state) => {
      state.user_userNotificationsLoading = true;
    });
    builder.addCase(user_userNotificationsFunc.fulfilled, (state, action) => {
      state.user_userNotificationsLoading = false;
      state.user_userNotificationsData = action.payload?.data?.user_userNotifications?.data;
      state.user_userNotificationsError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(user_userNotificationsFunc.rejected, (state, action) => {
      state.user_userNotificationsLoading = false;
      state.user_userNotificationsError = action.error;
    });
  },
});

export default user_userNotifications.reducer;
